import { Injectable } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { BehaviorSubject } from 'rxjs';
import { TcsConfigurationService } from 'src/app/core/configuration.service';
import { CompanyContextService } from 'src/app/shared/company-context.service';
import { createClientLinks } from 'src/util/apollo/apollo-client-links';
import { AppInsightsService } from 'src/lib/tcs-app-insights/app-insights-initializer.service';
import { AuthenticationService } from 'src/lib/tcs-identity/authentication.service';
import { Router } from '@angular/router';
import possibleTypesResultData from '../../../src/graphql/generated/graphql-possible-types.generated';
import { Logger } from '../shared/tcs-logging/logger';

const { possibleTypes } = possibleTypesResultData;

@Injectable({ providedIn: 'root' })
export class ApolloInitializerService {
  private _initialized$ = new BehaviorSubject(false);

  get initialized$() {
    return this._initialized$.asObservable();
  }

  constructor(
    private _apollo: Apollo,
    private _tcsConfig: TcsConfigurationService,
    private _httpLink: HttpLink,
    private _companyContext: CompanyContextService,
    private _logger: Logger,
    private _appInsightsService: AppInsightsService,
    private _authService: AuthenticationService,
    private _router: Router,
  ) {}

  public init() {
    this._apollo.create({
      link: createClientLinks(
        this._tcsConfig.value,
        this._companyContext,
        this._httpLink,
        this._logger,
        this._appInsightsService,
        this._authService,
        this._router,
      ),
      cache: new InMemoryCache({ possibleTypes }),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      },
    });
    this._initialized$.next(true);
  }
}
